import { render, staticRenderFns } from "./ProductInformation.vue?vue&type=template&id=234e4246&scoped=true&"
import script from "./ProductInformation.vue?vue&type=script&lang=js&"
export * from "./ProductInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234e4246",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/parker/lets_code/frances-valentine/new-fv-original/FV-original/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234e4246')) {
      api.createRecord('234e4246', component.options)
    } else {
      api.reload('234e4246', component.options)
    }
    module.hot.accept("./ProductInformation.vue?vue&type=template&id=234e4246&scoped=true&", function () {
      api.rerender('234e4246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductInformation.vue"
export default component.exports